'use client';

import styles from './FleetSalesImageCarousel.scss';
import { animate, motion, useMotionValue } from 'framer-motion';
import React, { useEffect } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import useMeasure from 'react-use-measure';
import FleetSalesImageCarouselCard from './FleetSalesImageCarouselCard/FleetSalesImageCarouselCard';

const image = [
  { url: '', alt: 'Photo 1' },
  { url: '', alt: 'Photo 3' },
  { url: '', alt: 'Photo 2' },
  { url: '', alt: 'Photo 4' },
];

const FleetSalesImageCarousel = ({ fields }) => {
  const [ref, { width }] = useMeasure();

  const xTranslation = useMotionValue(0);

  useEffect(() => {
    const finalPosition = -width / 2 - 5;

    const controls = animate(xTranslation, [0, finalPosition], {
      ease: 'linear',
      duration: 30,
      repeat: Infinity,
      repeatType: 'loop',
      repeatDelay: 0,
    });

    return controls.stop;
  }, [xTranslation, width]);

  return (
    <div className={'FleetSalesImageCarousel'}>
      <div className={'wrapper container'}>
        <section className={'imageCarousel'}>
          <div className={'title'} data-aos="fade-up">
            <div className={'titleText'}>
              <RichText field={fields?.title} />
            </div>
            <div className={'titleDescription'}>
              <RichText field={fields?.subTitle} />
            </div>
          </div>
          <div className={'mainContainer'} data-aos="fade-up">
            <motion.div ref={ref} className={'container'} style={{ x: xTranslation }}>
              {fields?.imgList?.map((item, idx) => (
                <FleetSalesImageCarouselCard key={idx} url={item.fields} alt={item.alt} />
              ))}
            </motion.div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FleetSalesImageCarousel;
